MultipleChoiceView = require "../multiple-choice-game/view"
Preloader          = require "lib/preload"
Prefix             = require "lib/prefix"

class ImageMultipleChoiceView extends MultipleChoiceView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  serialize: ->
    data = super

    answers = (@options.metadata.questions?[0]?.answers or [])
      .filter((el) -> el and el.content)
      .map (el) ->
        image: el.content
        correct: el.correct
        id: el.id

    data.tappies = _.shuffle(answers)

    return data

  answerDetails: ->
    questions = @options.metadata.questions or []
    return [] unless questions.length > 0

    question = questions[0]
    ids      = @getEl("selected").map (e) -> $(e).data('answer-id')
    answers  = question.answers.filter (a) -> a.id in ids
    details  = answers.map (a) -> question: question.question, answer: a
    return details

  selectAnswer: (e) -> 
    el = e.currentTarget
    if not el.classList.contains("correct") and @options.data.reject
      el.classList.add "show-incorrect"
      el.onanimationend = () ->
        el.classList.remove "show-incorrect"
      return
    
    super

  onResize: ->
    @setTappyHeight(true)

  show: ->
    super

    @listenTo this, "resize", @onResize

    @setTappyHeight()

  setTappyHeight: (isResize) ->
    unless @currentState?.refresh or isResize
      @el.classList.remove("active")

    @setEl @findOne(".tappies-parent"), "tappy-parent"
    @setEl @findAll(".tappy"), "tappies"
    @setEl @findOne(".title"), "title"
    @setEl @findOne(".tappies"), "tappy-container"

    Preloader.load _.pluck(@findAll("img"), "src"), (errors, imgs) =>

      parent    = @getEl("tappy-parent")
      container = @getEl("tappy-container")
      title     = @getEl("title")
      { tappies } = @serialize()

      for el in @getEl("tappies")
        el.style.opacity = 0

      container.style.height = parent.offsetHeight - title.offsetHeight + "px"

      iratio = _.chain(imgs)
        .map((el) -> el.naturalWidth / el.naturalHeight)
        .average()
        .value()

      cratio = parent.offsetWidth / (parent.offsetHeight - title.offsetHeight)
      factor = cratio / iratio

      rows = Math.round Math.sqrt(tappies.length * (iratio / cratio), 2)
      rows = Math.max(Math.min(rows, tappies.length), 1)
      cols = Math.round (tappies.length + tappies.length % rows) / rows

      for el in @getEl("tappies")
        el.style.height = "#{100 / rows}%"
        el.style.width  = "#{100 / cols}%"
        el.offsetWidth
        el.style.opacity = ""

      @fitText =>
        window.setTimeout (=> @el.classList.add("active")), 300

module.exports = ImageMultipleChoiceView
